/* Memerle — fiche produit : fil d'Ariane déplacé en haut de page, au-dessus de la photo */
(function () {
  function run() {
    var nav = document.querySelector('.product__info-container > .memerle-product-breadcrumb');
    var pdp = document.querySelector('.memerle-product-pdp');
    if (!nav || !pdp || !pdp.parentNode) return;
    nav.classList.add('memerle-product-breadcrumb--top');
    pdp.parentNode.insertBefore(nav, pdp);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
